import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 建行相关App跳转中间页
  {
    path: '/ccb/entry*',
    name: 'CcbEntry',
    component: () => import('@/views/ccb/entry'),
    meta: {
      title: '跳转中',
      showTab: false
    }
  },
  // 首页
  {
    path: '/',
    alias: '/index',
    name: 'Home',
    // 路由懒加载：https://router.vuejs.org/zh/guide/advanced/lazy-loading.html
    // webpackPreload：https://www.jianshu.com/p/bbdcfeee7fbc
    component: () => import(/* webpackPreload: true */ '@/views/home'),
    meta: {
      title: '天津益生堂生活馆',
      showTab: true,
      keepAlive: true
    }
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/login'),
    meta: {
      title: '登录'
    }
  },
  // 注册
  {
    path: '/registry',
    name: 'Registry',
    component: () => import('@/views/auth/login'),
    meta: {
      title: '注册'
    }
  },
  // 分类
  {
    path: '/category',
    name: 'Category',
    component: () => import('@/views/category'),
    meta: {
      title: '分类',
      showTab: true,
      keepAlive: true
    }
  },
  // 购物车
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/cart'),
    meta: {
      title: '购物车',
      showTab: true
    }
  },
  // 我的
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user'),
    meta: {
      title: '我的',
      showTab: true
    }
  },
  // 用户设置
  {
    path: '/userSetting',
    name: 'UserSetting',
    component: () => import('@/views/userSetting'),
    meta: {
      title: '用户设置',
      showTab: true
    }
  },
  // 用户设置-昵称
  {
    path: '/userSetting/nickname',
    name: 'UserSetNickname',
    component: () => import('@/views/userSetting/nickname'),
    meta: {
      title: '设置昵称',
      showTab: true
    }
  },
  // 用户设置-生日
  {
    path: '/userSetting/birthday',
    name: 'UserSetBirthday',
    component: () => import('@/views/userSetting/birthday'),
    meta: {
      title: '设置生日',
      showTab: true
    }
  },
  // 用户设置-性别
  {
    path: '/userSetting/gender',
    name: 'UserSetGender',
    component: () => import('@/views/userSetting/gender'),
    meta: {
      title: '设置性别',
      showTab: true
    }
  },
  // 用户设置-邮箱
  {
    path: '/userSetting/email',
    name: 'UserSetEmail',
    component: () => import('@/views/userSetting/email'),
    meta: {
      title: '设置邮箱',
      showTab: true
    }
  },
  // 用户设置-手机
  {
    path: '/userSetting/mobile',
    name: 'UserSetMobile',
    component: () => import('@/views/userSetting/mobile'),
    meta: {
      title: '设置手机号',
      showTab: true
    }
  },
  // 用户设置-密码
  {
    path: '/userSetting/password',
    name: 'UserSetPassword',
    component: () => import('@/views/userSetting/password'),
    meta: {
      title: '设置密码',
      showTab: true
    }
  },
  // 订单列表
  {
    path: '/user/order/list/:active',
    name: 'OrderList',
    props: true,
    component: () => import('@/views/order/list'),
    meta: {
      title: '订单列表',
      showTab: true
    }
  },
  // 商品列表
  {
    path: '/product/:categoryLevel/:cateId',
    name: 'Product',
    props: true,
    component: () => import('@/views/product'),
    meta: {
      title: '商品列表',
      keepAlive: true
    }
  },
  // 金刚位跳转商品列表
  {
    path: '/diamondGoodsList/:diamondId',
    name: 'Diamand',
    props: true,
    component: () => import('@/views/diamondGoodsList'),
    meta: {
      title: '商品列表',
      keepAlive: true
    }
  },
  // 商品详情
  {
    path: '/detail/:goodsId',
    name: 'Detail',
    props: true,
    component: () => import('@/views/detail'),
    meta: {
      title: '商品详情',
      keepAlive: true
    }
  },
  // 商品评论
  {
    path: '/detail/comment/:goodsId/:tagType',
    name: 'Comment',
    props: true,
    component: () => import('@/views/detail/comment'),
    meta: {
      title: '商品评论'
    }
  },
  // 地址管理
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/address/list'),
    meta: {
      title: '地址管理'
    }
  },
  // 地址编辑
  {
    path: '/address/edit',
    name: 'AddressEdit',
    component: () => import('@/views/address/edit'),
    meta: {
      title: '地址编辑'
    }
  },
  // 搜索
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search'),
    meta: {
      title: '搜索'
    }
  },
  // 搜索结果
  {
    path: '/search/list',
    name: 'SearchList',
    component: () => import('@/views/search/list'),
    meta: {
      title: '搜索结果'
    }
  },
  // 确认订单
  {
    path: '/order/confirm',
    name: 'OrderConfirm',
    component: () => import('@/views/order/confirm'),
    meta: {
      title: '确认订单',
      keepAlive: true
    }
  },
  // 订单支付
  {
    path: '/order/pay',
    name: 'OrderPay',
    component: () => import('@/views/order/pay'),
    meta: {
      title: '订单支付'
    }
  },
  // 订单详情
  {
    path: '/order/detail/:orderSn',
    name: 'OrderDetail',
    props: true,
    component: () => import('@/views/order/detail'),
    meta: {
      title: '订单详情'
    }
  },
  // 积分页面
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/points/index'),
    meta: {
      title: '我的积分'
    }
  },

  // 售后申请
  {
    path: '/order/aftersale/apply/:orderSn',
    name: 'OrderAftersaleApply',
    props: true,
    component: () => import('@/views/order/aftersale/apply'),
    meta: {
      title: '申请售后'
    }
  },
  // 售后列表
  {
    path: '/order/aftersale/list',
    name: 'OrderAftersaleList',
    component: () => import('@/views/order/aftersale/list'),
    meta: {
      title: '售后列表'
    }
  },
  // 售后详情
  {
    path: '/order/aftersale/detail/:aftersaleId',
    name: 'OrderAftersaleDetail',
    props: true,
    component: () => import('@/views/order/aftersale/detail'),
    meta: {
      title: '售后详情'
    }
  },
  // 开票申请
  {
    path: '/order/invoice/apply/:orderId',
    name: 'OrderInvoiceApply',
    props: true,
    component: () => import('@/views/order/invoice/apply'),
    meta: {
      title: '申请开票'
    }
  },
  // 支付状态
  {
    path: '/order/payStatus',
    name: 'PayStatus',
    props: true,
    component: () => import('@/views/order/payStatus')
  },
  // 公告列表
  {
    path: '/notice/list',
    name: 'NoticeList',
    component: () => import('@/views/notice/list'),
    meta: {
      title: '公告'
    }
  },
  // 公告详情
  {
    path: '/notice/detail/:id',
    name: 'NoticeDetail',
    props: true,
    component: () => import('@/views/notice/detail'),
    meta: {
      title: '公告详情'
    }
  },
  // 优惠券
  {
    path: '/order/coupon',
    name: 'coupon',
    component: () => import('@/views/order/coupon'),
    meta: {
      title: '优惠券',
      showTab: true
    }
  },
  // 优惠券
  {
    path: '/order/my',
    name: 'couponMy',
    component: () => import('@/views/order/my'),
    meta: {
      title: '优惠券',
      showTab: true
    }
  },
  // 评论页面
  {
    path: '/goodsComment/:orderGoodsId/:goodsId',
    name: 'GoodsComment',
    props: true,
    component: () => import('@/views/goodsComment'),
    meta: {
      title: '商品评论'
    }
  },
  // 404 / 默认未匹配路由重定向首页
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  // 记录上个页面的滚动位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
